import { SettingsActions } from 'redux/reducers/settings';
import { store } from 'redux/store';

export class SettingsService {
  static toggleSidebarWidth() {
    return store.dispatch(SettingsActions.toggleSidebarWidth());
  }
  static setPermissions(payload) {
    return store.dispatch(SettingsActions.setPermissions(payload));
  }
}

const addGlobals = () => {
  window.__SettingsService = SettingsService;
};
addGlobals();

void module?.hot?.accept?.(['./SettingsService.js'], () => addGlobals());
